/* One-click, full-screen viewing for legacy Casa DaVinci image collections.
   The artwork gallery and Living Light viewer retain their own richer controls. */
(() => {
  const selector = '.cdv-gallery img, .cdv-display-track img, .cdv-branch-whole img, .cdv-branch-puzzle img';
  let dialog, fullImage, previousFocus, previousOverflow;
  function ensureDialog() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'cdv-universal-viewer';
    dialog.setAttribute('aria-label', 'Full-screen artwork image');
    dialog.innerHTML = '<button type="button" class="cdv-universal-viewer-close" aria-label="Close image">×</button><img alt="">';
    const style = document.createElement('style');
    style.textContent = '.cdv-universal-viewer{position:fixed;inset:0;box-sizing:border-box;margin:0;padding:44px 12px 20px;border:0;background:#111a1b;color:#fff;width:100vw;max-width:100vw;height:100dvh;max-height:100dvh;overflow:hidden}.cdv-universal-viewer::backdrop{background:#111a1b}.cdv-universal-viewer[open]{display:flex;align-items:center;justify-content:center}.cdv-universal-viewer img{display:block;max-width:100%;width:auto;height:auto;max-height:calc(100dvh - 76px);object-fit:contain}.cdv-universal-viewer-close{position:absolute;right:12px;top:8px;font:32px/1 sans-serif;width:44px;height:44px;border:1px solid #fff;border-radius:5px;background:#253a3a;color:white;cursor:pointer;z-index:2}.cdv-universal-viewer-close:focus-visible{outline:3px solid #fff;outline-offset:3px}.cdv-gallery img,.cdv-display-track img,.cdv-branch-whole img,.cdv-branch-puzzle img{cursor:zoom-in}';
    document.head.append(style);
    document.body.append(dialog);
    fullImage = dialog.querySelector('img');
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = previousOverflow;
      fullImage.removeAttribute('src');
      previousFocus?.focus?.({ preventScroll: true });
    });
  }
  function highResolution(src) {
    try {
      const url = new URL(src, location.href);
      if (url.hostname.endsWith('shopify.com') || url.hostname.endsWith('shopifycdn.com')) {
        url.searchParams.set('width', '2400');
      }
      return url.href;
    } catch { return src; }
  }
  function makeKeyboardAccessible() {
    document.querySelectorAll(selector).forEach(img => {
      if (img.closest('a,[data-cdv-artwork],.cdv-store-products')) return;
      img.tabIndex = 0;
      img.setAttribute('role', 'button');
      img.setAttribute('aria-label', (img.alt || 'Artwork image') + ' — view full screen');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', makeKeyboardAccessible);
  else makeKeyboardAccessible();
  document.addEventListener('shopify:section:load', makeKeyboardAccessible);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const img = event.target.closest?.(selector);
    if (!img || img.closest('a,[data-cdv-artwork],.cdv-store-products')) return;
    event.preventDefault();
    img.click();
  });
  document.addEventListener('click', event => {
    const img = event.target.closest?.(selector);
    if (!img || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    if (img.closest('[data-cdv-artwork],.cdv-store-products')) return;
    const link = img.closest('a');
    if (link?.hasAttribute('data-cdv-photo-open') || link?.hasAttribute('data-cdv-store-zoom')) return;
    if (link) {
      const url = new URL(link.href, location.href);
      const directImage = /\.(?:jpe?g|png|webp|avif|gif|bmp)(?:$|[?#])/i.test(url.href);
      if (!directImage) return; // Preserve actual artwork/navigation links.
    }
    event.preventDefault();
    ensureDialog();
    previousFocus = link || img;
    previousOverflow = document.documentElement.style.overflow;
    const src = link?.href || img.currentSrc || img.src;
    fullImage.src = highResolution(src);
    fullImage.alt = img.alt || '';
    if (!dialog.open) { dialog.showModal(); document.documentElement.style.overflow = 'hidden'; }
  });
})();